import { trackEvent } from '@/common/store/pinia/telemetry/core/client';

export const trackSlowRequestDetected = (
  request_id: string,
  request_url: string,
  request_method: string
): void => {
  trackEvent('slow_request_detected', {
    request_id,
    request_url,
    request_method
  });
};

export const trackRequestComplete = (
  request_id: string,
  request_url: string,
  request_method: string,
  status: RequestStatus,
  duration_ms: number
): void => {
  trackEvent('slow_request_completed', {
    request_id,
    request_url,
    request_method,
    status,
    duration_ms
  });
};
